import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import createStore from './store'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Theme from './components/Theme'

import AdminPage from './components/admin/AdminPage'
import DeviceListPage from './components/device/DeviceListPage'
import TimeseriesListPage from './components/timeseries/TimeseriesListPage'
import TimeseriesDetailsPage from './components/timeseries/TimeseriesDetailsPage'
import UnitDetailsPage from './components/unit/UnitDetailsPage'
import CommunityDetailsPage from './components/community/CommunityDetailsPage'
import CommunityUsersPage from './components/user/CommunityUsersPage'
import DoorAccessDetailsPage from './components/dooraccess/DoorAccessDetailsPage'
import OrganizationUsersPage from './components/user/OrganizationUsersPage'
import AlertRulesListPage from './components/alertrules/AlertRulesListPage'
import CommunityDoorAccessPage from './components/admin/CommunityDoorAccessPage'
import UnitAutomationsListPage from './components/automations/UnitAutomationsListPage'
import AuthLayout from './components/authentication/Layout'
import IntroLayout from './components/intro/Layout'
import Intro from './components/intro/Intro'
import Login from './components/authentication/Login'
import Callback from './components/authentication/Callback'
import ForgotPassword from './components/authentication/ForgotPassword'
import ResetPassword from './components/authentication/ResetPassword'
import LoginLinkExpired from './components/authentication/LoginLinkExpired'
import InitialSetup from './components/intro/InitialSetup'
import NoMatch from './components/NoMatch'
import * as AuthenticationActionCreators from './actions/authentication'

import '../styles/app.css'

const store = createStore()

store.dispatch(AuthenticationActionCreators.loadAuth())

ReactDOM.render(
  <Provider store={store}>
    <Theme>
      <BrowserRouter onUpdate={() => window.scrollTo(0, 0)}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route path="/login/forgot" component={ForgotPassword} />
          <Route path="/login/expired" component={LoginLinkExpired} />
          <Route path="/magiclink" component={Callback} />
          <Route path="/callback" component={Callback} />
          <ProtectedRoute exact path="/login/reset" layout={AuthLayout} component={ResetPassword} />
          <ProtectedRoute ensureAdmin exact path="/" layout={Layout} component={AdminPage} />
          <ProtectedRoute ensureAdmin exact path="/units/:unitId" layout={Layout} component={UnitDetailsPage} />
          <ProtectedRoute ensureAdmin exact path="/units/:unitId/devices" layout={Layout} component={DeviceListPage} />
          <ProtectedRoute ensureAdmin exact path="/units/:unitId/rules" layout={Layout} component={AlertRulesListPage} />
          <ProtectedRoute ensureAdmin exact path="/units/:unitId/timeseries" layout={Layout} component={TimeseriesListPage} />
          <ProtectedRoute ensureAdmin exact path="/units/:unitId/timeseries/:tsId" layout={Layout} component={TimeseriesDetailsPage} />
          <ProtectedRoute ensureAdmin exact path="/units/:unitId/automations" layout={Layout} component={UnitAutomationsListPage} />
          <ProtectedRoute ensureAdmin exact path="/communities/:communityId" layout={Layout} component={CommunityDetailsPage} />
          <ProtectedRoute ensureAdmin exact path="/communities/:communityId/users" layout={Layout} component={CommunityUsersPage} />
          <ProtectedRoute ensureAdmin exact path="/communities/:communityId/access" layout={Layout} component={CommunityDoorAccessPage} />
          <ProtectedRoute ensureAdmin exact path="/dooraccess/:accessId" layout={Layout} component={DoorAccessDetailsPage} />
          <ProtectedRoute ensureAdmin exact path="/organizations/:organizationId/users" layout={Layout} component={OrganizationUsersPage} />
          <ProtectedRoute exact path="/intro" layout={IntroLayout} component={Intro} />
          <ProtectedRoute exact path="/setup" layout={IntroLayout} component={InitialSetup} />
          <Route path="*" component={NoMatch} />
        </Switch>
      </BrowserRouter>
    </Theme>
  </Provider>,
  document.getElementById('root'),
)
